import { environment } from '../../environments/environment';
import { PlaidAccountSummary, Transaction } from '../types';

export function effectiveTransactionPlaidAccount(
  transaction: Transaction | null | undefined,
): PlaidAccountSummary | undefined {
  return transaction?.plaidAccount ?? transaction?.parent?.plaidAccount;
}

export function hasTransactionSyncedFinancialFacts(transaction: Transaction | null | undefined): boolean {
  if (!transaction) return false;
  return [transaction, transaction.parent].some(
    source => source?.plaidAccount != null || source?.bankMeta != null || !!source?.merchantMeta?.originalName,
  );
}

export function transactionPlaidAccountDisplayName(account: PlaidAccountSummary | null | undefined): string {
  if (account?.nickname) return account.nickname;
  if (account?.mask) return `••${account.mask}`;
  return 'Account';
}

export function transactionInstitutionLogoSrc(account: PlaidAccountSummary | null | undefined): string | null {
  const logoUrl = account?.institution?.logoUrl;
  if (!logoUrl) return null;
  if (!logoUrl.startsWith('/api/')) return logoUrl;

  return `${environment.restUrl}${logoUrl}`;
}

export function hasTransactionBankImportDetails(transaction: Transaction | null | undefined): boolean {
  if (transaction?.merchantMeta?.originalName) return true;

  const account = effectiveTransactionPlaidAccount(transaction);
  if (!account) return false;

  return !!(
    account.nickname ||
    account.officialName ||
    account.name ||
    account.institution?.name ||
    account.mask
  );
}
